"use client";
import { useEffect } from "react";

const InvalidUrlRedirect = () => {
  useEffect(() => {
    if (window.location.pathname.includes("//")) {
      window.location.replace("/404");
    }
  }, []);

  return null;
};

export default InvalidUrlRedirect;
